const getHeaderToken = {
    "headers": {"tokenId":"U2FsdGVkX18cwq3S7v2bT+E9T9XkTfH4D4Gp+gWZFok="}
}
export default getHeaderToken
